import { Player } from '@gumlet/player.js';
import { useEffect, useRef, useState } from 'react';
import API from '../../../services/API';
import Loader from '../../Tools/Loader';
import Error from './Error';

export default function Gumlet({section}){

    const [source, setSource] = useState(null)

    const [status, setStatus] = useState('loading')

    const iframe = useRef(null)

    useEffect(() => {

        let active = true

        API.get(`/study/sections/${section.id}/gumlet`)
            .then(r => {
                if(!active) return;
                setSource(r.data?.source || null)
                setStatus(r.data?.source ? 'success' : 'error')
            })
            .catch(_ => active && setStatus('error'))

        return () => {

            active = false

            setSource(null)

            setStatus('loading')
        }

    }, [section.id])

    useEffect(() => {

        if(!source || !iframe.current) return;

        const player = new Player(iframe.current);

        player.on('ready', () => {
            player.on('ended', () => {
                document.getElementById('next-button')?.click();
            });
        });

        return () => player.destroy();

    }, [source])


    if( status === 'loading' ) return <Loader />;

    if( status === 'error' ) return <Error />;

    return <iframe
        ref={iframe}
        title={section.title}
        src={source}
        width="100%"
        height="99%"
        frameBorder="0"
        allow="autoplay; fullscreen; encrypted-media; picture-in-picture"
        allowFullScreen={true}
    >
    </iframe>
}
